import { createSlice } from '@reduxjs/toolkit'
import UsersServices from '../../services/usersServices';

const initialState = {
  roles: []
};

const rolesSlice = createSlice({
  name: 'roles',
  initialState,
  reducers: {
    rolesLoaded(state, action) {
      state.roles = action.payload;
    }
  },
})

export const { rolesLoaded } = rolesSlice.actions;

export default rolesSlice.reducer;

export const fetchRolesList = () => async (dispatch) => {
  let filters = { roleName: null }
  try {
    const respData = await UsersServices.getRoles(filters);
    if (respData.success) {
      const roles = respData.responseObject.value.rolesList;
      if (roles) {
        const objectsArray = roles.map((item) => ({ value: item.id, label: item.name }));
        dispatch(rolesLoaded(objectsArray));
      }
    }
  } catch (error) {
    console.error('Failed to fetch:', error.message);
  }
};

